<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        <v-col><h1>Login information</h1></v-col>
                    </v-card-title>
                    <v-card-title>
                        <v-col cols='12'>
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                                max-width="200px"
                            >
                            </v-text-field>
                        </v-col>
                    </v-card-title>
                    <v-data-table 
                        :headers="headers" 
                        :items="table_data" 
                        :search="search" 
                        class="elevation-1"

                    >
    
                        <template v-slot:item.index="{ item }">
                            {{table_data.findIndex(items => { return items.id == item.id})+1}}
                        </template>
                  
                        <template v-slot:item.account="{item}">
                            <a class="mt-5">
                                <span @click="toAccount(item)">{{ item.account}}</span>
                            </a>
                        </template>
                        <template v-slot:item.company="{item}">                           
                                {{ item.company}}
                        </template>
                        <template v-slot:item.login_time="{item}">
                            <span v-if="item.login_time != null">{{ item.login_time | moment}}</span>
                            <span v-if="item.login_time == '' || item.login_time == null"> - </span>
                        </template>
                        <template v-slot:item.logout_time="{item}">
                            <span v-if="item.logout_time != null">{{ item.logout_time | moment}}</span>
                            <span v-if="item.logout_time == '' || item.logout_time == null"> - </span>
                            
                        </template>
                        <!-- <template v-slot:item.set="{item}">
                            <v-btn class="ml-3 mt-3" color="primary" @click="update(item)">修改</v-btn>
                            <v-btn class="ml-3 mt-3" color="error" @click="remove(item)">刪除</v-btn>
                        </template> -->
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import moment from 'moment'
import axios from 'axios'
var host_url = process.env.VUE_APP_HOST_URL

export default {

    filters: {
        moment: function (date) {
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
        }
    },
    data(){
        return {
            headers: [
                {text: 'No.', align: 'start', value: 'index', width: 50, class: "pa-5"},
                {text: 'Account', align: 'start', value: 'account', width: 120, class: "pa-5"},
                {text: 'Company', align: 'start', value: 'company', width: 120, class: "pa-5"},
                {text: 'Login time', align: 'start', value: 'login_time', width: 80, class: "pa-5"},
                {text: 'Logout time', align: 'start', value: 'logout_time', width: 80, class: "pa-5"},
                {text: 'IP', align: 'start', value: 'ip', width: 80, class: "pa-5"},
                {text: 'Error message', align: 'center', value: 'error_msg', width: 80, class: "pa-5"},
            ],
            table_data: [],
            search: '',
            specialSearch: false,
        }
    },
    created(){
        this.getLogin()
        let check_search = this.$route.query.params
        // console.log(check_search)
        if(check_search){
            this.search = check_search
        }
    },
    methods:{
        getLogin(){
            axios.get(host_url+'account/get_login/')
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    this.table_data = tmp.data    
                }
                
            })
        },
        toAccount(item){
            this.$router.push({path: '/account_overview', query: { params: item.account }})
        },
    }
}
</script>
